export default "__VITE_ASSET__B0L5e39f__"